import { Vencimientos } from '../models/vencimientos';

export class Utils {

  getRemaining(value: number) {
    if ( Vencimientos[`${value}`] !== undefined) {
      return Vencimientos[`${value}`];
    } else {
      if (value <= 0) { return 'Vencido'; }
      if (value <= 60) { return 'Menos de 1 minuto'; }
      if (value < 120) { return '1 minuto'; }
      if (value < 3600) {
        return `${Math.round(value / 60)} minutos`;
      }
      return this.convertSeconds(value);
    }
  }

  getRemainingFormat(value: any) {


    if ( Vencimientos[`${value}`] !== undefined) {
      return Vencimientos[`${value}`];
    } else {
      if(isNaN(value)){
        return value;
      }
      if (value <= 0) { return 'Vencido'; }
      if (value <= 60) { return 'Menos de 1 minuto'; }
      if (value < 120) { return '1 minuto'; }
      if (value < 3600) {
        return `${Math.round(value / 60)} minutos`;
      }
      return this.convertSeconds(value);
    }
  }

   convertSeconds(seconds) {
    seconds = seconds +2;
    let days = Math.round(Math.floor(seconds / 86400));
    let hours = Math.round(Math.floor((seconds % 86400) / 3600));
    let minutes = Math.round(Math.floor(((seconds % 86400) % 3600) / 60));
    let texDay = 'dias';
    let texHour = 'horas';

    if(days == 1){
      texDay = 'dia';
    }
    if(hours == 1){
      texHour = 'hora';
    }

    let textReturn = days + " " +texDay + ", "+  hours + " " +texHour + ", "+  minutes + " minutos";

    if (days == 0){
      textReturn = hours + " " +texHour + ", "+  minutes + " minutos";
      if(minutes == 0){
        textReturn = hours + " " +texHour;
      }
    }

    if (days == 0 && hours == 0){
      textReturn =  minutes + " minutos";
    }

    return textReturn;
  }

   convertSecondsToHoursAndMinutes(seconds) {
    var hours = Math.floor(seconds / 3600);
    var minutes = Math.floor((seconds - (hours * 3600)) / 60);
    return hours + " horas y " + minutes + " minutos";
    }

  isLink(value): boolean {
    return value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/) !== null;
  }

  formatoRut(rut) {
    if (rut && rut.length > 7) {
      const rev = rut
        .replace(/[\.-]+/g, '')
        .split('').reverse().join('');
      const formated = rev.substr(0, 1) + '-' + rev.substr(1, 3)
      + '.' + rev.substr(4, 3) + '.' + rev.substr(7, 2);
      formated.split('').reverse().join('');
      rut = formated.split('').reverse().join('');
    }
    return rut;
  }

  getParameterByName (name) {
    const params = new URL(window.location.href).searchParams;
    return params.get(name);
  }

}
